import {SearchItem, SearchResultDto} from "./search-table.dto.res";
import {ReceiptDto} from "../receipt.dto";
import {DocumentContactDto} from "../document-contact.dto";
import {DocumentPaymentDto} from "../document-payment.dto";
import {DocumentContactType} from "../../../libs/enum/document-contact-type";
import {ContactType} from "../../../libs/enum/contact-type";

export class SearchReceiptRes extends SearchResultDto {

  public override readonly items: SearchReceiptItem[] = [];

  constructor(init?: Partial<SearchReceiptRes>) {
    super(init);
    if (init?.items) {
      this.items = init.items.map((i) => new SearchReceiptItem(i));
    } else {
      this.items = [];
    }
  }
}

export class SearchReceiptItem extends ReceiptDto implements SearchItem {

  // Destination-Contact
  // ReceiptDto: destinationContactId
  public destinationContactType: ContactType | undefined;
  public destinationContactNumber: string | undefined;
  public destinationContactFullName: string | undefined;

  // Document-Contact
  public dcId!: string;
  public dcType!: DocumentContactType;
  public dcContactId!: string;
  public dcContactType: string | undefined;
  public dcContactFullName: string | undefined;
  public dcContactNumber: string | undefined;
  // Payment
  public readonly paymentId!: string;
  public readonly paymentCompleted!: boolean;
  public readonly paymentBalance!: number;

  constructor(init?: Partial<SearchReceiptItem>) {
    super(init);
    Object.assign(this, init);
    this.contact = new DocumentContactDto({
      id: this.dcId,
      type: this.dcType,
      contactId: this.dcContactId,
      contactType: this.dcContactType,
      number: this.dcContactNumber,
      fullName: this.dcContactFullName
    });
    this.payment = new DocumentPaymentDto({
      id: this.paymentId,
      completed: this.paymentCompleted,
      balance: this.paymentBalance,
    });
  }
}
